/**
 * Карточка землетрясения на любой карте кабинета.
 *
 * Хук, а не копия в каждой странице: землетрясения — общее наложение, их
 * рисуют и «Карты», и «Модели» из одного стора (`useOverlays`), и вторая копия
 * этой связки разъехалась бы с первой при первой же правке.
 *
 * Вся логика «что показывать» живёт в чистом `quakeCardState`; здесь только
 * состояние React и три готовых обработчика для `MapCanvas`.
 */
import { useCallback, useState } from 'react'
import {
  NO_QUAKE_CARD,
  onQuakeClick,
  onQuakeClose,
  onQuakeHover,
  quakeCardShown,
  type QuakeHit,
} from '../models/quakeCardState'

export function useQuakeCard() {
  const [state, setState] = useState(NO_QUAKE_CARD)
  const handleHover = useCallback(
    (hit: QuakeHit | null) => setState(s => onQuakeHover(s, hit)),
    [],
  )
  const handleClick = useCallback((hit: QuakeHit) => setState(s => onQuakeClick(s, hit)), [])
  const close = useCallback(() => setState(s => onQuakeClose(s)), [])
  return { shown: quakeCardShown(state), handleHover, handleClick, close }
}
